import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BrowserStorageService } from './service/browser-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // SSR-safe: on the server this always returns null, so server-side
  // requests are made unauthenticated (public data only).
  const token = inject(BrowserStorageService).getItem('token');

  if (!token) {
    return next(req);
  }

  if (req.url.includes('/login') || req.url.includes('/register')) {
    return next(req);
  }

  if (req.url.includes('files.')) {
    return next(req);
  }

  if (req.url.includes('file-upload.')) {
    return next(req);
  }

  const modifiedReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });

  return next(modifiedReq);
};
